class YandexMapLoader {
	static _loading = null;

	load(afterLoad = null) {
		if (!YandexMapLoader._loading) {
			// Все компоненты используют один запрос к API и ожидают готовность через ymaps.ready.
			YandexMapLoader._loading = new Promise(resolve => {
				let script = this.getIncluded();
				const included = Boolean(script);
				if (!script) {
					script = document.createElement('script');
					script.setAttribute('src', `https://api-maps.yandex.ru/2.1/?apikey=${App.ymap.token}&suggest_apikey=${App.ymap.token_suggest}&lang=ru_RU`);
					script.setAttribute('id', 'ymap');
				}
				const ready = () => {
					if (typeof ymaps === 'undefined') { failed(); return; }
					ymaps.ready(() => {
						script.dataset.loaded = 'true';
						resolve(true);
					});
				};
				const failed = () => {
					script.remove();
					resolve(false);
				};
				if (this.isLoaded()) ready();
				else {
					script.addEventListener('load', ready, { once: true });
					script.addEventListener('error', failed, { once: true });
					if (!included) document.head.appendChild(script);
				}
			}).then(ready => {
				if (!ready) YandexMapLoader._loading = null;
				return ready;
			});
		}
		return YandexMapLoader._loading.then(ready => {
			if (ready && typeof afterLoad === 'function') afterLoad();
			return ready;
		});
	}

	loadIfVisible(element, callback) {
		const observer = new window.IntersectionObserver(([entry]) => {
			if (entry.isIntersecting) {
				this.load(callback);
				observer.disconnect();
			}
		}, {
			root: null,
			threshold: 0.1,
		})

		observer.observe(element);
	}

	getIncluded() {
		return document.querySelector('script#ymap');
	}

	isIncluded() {
		return Boolean(this.getIncluded());
	}

	isLoaded() {
		return this.getIncluded()?.dataset.loaded;
	}
}

export default YandexMapLoader;
